import type { SVGProps, ReactElement } from 'react'

const Wishlist = (props: SVGProps<SVGSVGElement>): ReactElement => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <path
                d="M29.7767 14.698C29.0794 12.8812 26.7396 12.0105 24.7613 12.3779C23.1844 12.7439 21.7365 13.5136 20.5672 14.6074C20.3238 13.9374 19.9483 13.3202 19.4618 12.7906C17.561 10.7271 13.935 10.1936 11.8121 12.0407C9.68921 13.8877 9.74603 16.9678 10.402 19.59C11.2026 22.6449 15.3968 29.092 17.4835 29.092C19.5703 29.092 27.566 22.811 29.3119 18.7595C29.8646 17.456 30.2726 16.0015 29.7767 14.698Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default Wishlist
